import { createRoute } from '@tanstack/react-router';
import { LoginPage } from './login';
import { rootRoute } from './routes';

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
});
